<div class="form-div">
  <form class="login-form" id="basicInfoForm" [formGroup]="loginForm">
    <h2 i18n>Login</h2>
    <p class="mb-3" i18n>Please login to your account to continue the process.</p>
    <div class="form-floating mb-3">
      <input type="email" class="form-control" id="floatingInputEmail" formControlName="email" placeholder="Email Address" [ngClass]="{'is-invalid': (email?.touched && email?.invalid) || signupService.loginEmailErrorMessage !== null}">
      <label for="floatingInputEmail" i18n>Email Address</label>
      <div class="invalid-feedback" *ngIf="email?.touched && email?.invalid">
        <div *ngIf="email?.hasError('required')" i18n>Email is required.</div>
        <div *ngIf="email?.hasError('email')" i18n>Incorrect email format.</div>
      </div>
      <div class="invalid-feedback" *ngIf="signupService.loginEmailErrorMessage !== null">{{ signupService.loginEmailErrorMessage }}</div>
    </div>
    <div class="form-floating mb-3 password-div">
      <input [type]="showPasswordFieldText ? 'text' : 'password'" class="form-control password-field" id="floatingInputPassword" formControlName="password" placeholder="Password" [ngClass]="{'is-invalid': (password?.touched && password?.invalid) || signupService.loginPasswordErrorMessage !== null}">
      <label for="floatingInputPassword" i18n>Password</label>
      <i class="bi bi-eye-fill password-show-icon" (click)="togglePasswordShowButtonClicked()"></i>
      <div class="invalid-feedback" *ngIf="password?.touched && password?.invalid">
        <div *ngIf="password?.hasError('required')" i18n>Password is required.</div>
        <div *ngIf="password?.hasError('minlength')" i18n>Password must be more than 8 characters.</div>
        <div *ngIf="password?.hasError('maxlength')" i18n>Password too long.</div>
<!--        <div *ngIf="password?.hasError('passwordStrength')">Password must contain at least one uppercase letter, one lowercase letter, and one special character.</div>-->
      </div>
      <div class="invalid-feedback" *ngIf="signupService.loginPasswordErrorMessage !== null">{{ signupService.loginPasswordErrorMessage }}</div>
    </div>

    <div class="alert alert-danger form-alert" *ngIf="signupService.loginFormErrorMessage !== null">{{ signupService.loginFormErrorMessage }}</div>

  </form>
</div>
